import { createContext, useContext } from 'react';

import { TaskProcessorContextValue } from './TaskProcessorProvider';

export const TaskProcessorProviderContext =
  createContext<TaskProcessorContextValue | null>(null);

export const useTaskProcessor = () => {
  const taskProcessor = useContext(TaskProcessorProviderContext);
  if (!taskProcessor) {
    throw new Error(
      'useTaskProcessor must be used within TaskProcessorProvider',
    );
  }
  return taskProcessor;
};
